import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '../ui/Button';
import { Upload, Search, Eye } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
const steps = [{
  number: '01',
  icon: Upload,
  title: 'Upload photo + measurements',
  description: 'Take a quick photo and add a few key measurements. Our AI analyzes your proportions in seconds.'
}, {
  number: '02',
  icon: Search,
  title: 'Choose your brand',
  description: "Browse brands like Ann Taylor, Banana Republic, J.Crew—we'll show you what works for your frame."
}, {
  number: '03',
  icon: Eye,
  title: 'See it on your body instantly',
  description: 'Our visualization shows exactly how the dress will fit you—before you buy. No more guessing.'
}];
export function HowItWorks() {
  const navigate = useNavigate();
  return <section className="py-24 bg-primary relative overflow-hidden" data-id="element-88">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-89">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-90">
          <h2 className="text-3xl md:text-5xl font-bold text-text-primary mb-4" data-id="element-91">
            How It Works
          </h2>
          <p className="text-lg text-text-muted" data-id="element-92">
            Three simple steps to see your perfect fit.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-12 relative mb-16" data-id="element-93">
          {/* Connecting line for desktop */}
          <div className="hidden md:block absolute top-8 left-0 w-full h-0.5 bg-gray-200 -z-10" data-id="element-94" />

          {steps.map((step, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.2
        }} className="relative flex flex-col items-center text-center" data-id="element-95">
              <div className="w-16 h-16 bg-white rounded-full flex items-center justify-center shadow-sm border-4 border-primary mb-6 relative" data-id="element-96">
                <step.icon className="w-6 h-6 text-accent" data-id="element-97" />
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-accent rounded-full flex items-center justify-center text-xs font-bold text-white" data-id="element-98">
                  {index + 1}
                </div>
              </div>
              <h3 className="text-xl font-bold text-text-primary mb-3 font-serif" data-id="element-99">
                {step.title}
              </h3>
              <p className="text-text-muted max-w-xs mx-auto" data-id="element-100">
                {step.description}
              </p>
            </motion.div>)}
        </div>

        <div className="text-center" data-id="element-101">
          <Button variant="primary" size="lg" onClick={() => navigate('/try-it')} data-id="element-102">
            Start Your Profile
          </Button>
        </div>
      </div>
    </section>;
}